module.exports = __webpack_public_path__ + "static/img/working.9973c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/working.png
// module id = 2poy
// module chunks = 0